import { render, staticRenderFns } from "./LayoutAnan.vue?vue&type=template&id=23965659&"
import script from "./LayoutAnan.vue?vue&type=script&lang=js&"
export * from "./LayoutAnan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports